import { Component } from "react";
import { AuthContext } from "./context/AuthContext.jsx";
import { useContext } from "react";

// 全局错误边界：任何渲染异常都兜底成"可重试" UI，绝不白屏。
export default class GlobalErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error("[GlobalErrorBoundary]", error, info);
  }
  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            minHeight: "100svh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 16,
            padding: 24,
            textAlign: "center",
            fontFamily: "sans-serif",
            color: "#1e1420",
          }}
        >
          <div style={{ fontSize: 40 }}>😵</div>
          <p style={{ margin: 0, fontSize: 16, fontWeight: 600 }}>页面加载出错了</p>
          <p style={{ margin: 0, fontSize: 13, color: "#5b4a58", maxWidth: 300 }}>
            别担心，你的数据都还在。点下方按钮重试。
          </p>
          <button
            onClick={() => {
              this.setState({ error: null });
              window.location.reload();
            }}
            style={{
              height: 48,
              padding: "0 28px",
              fontSize: 15,
              color: "#fff",
              background: "#db2777",
              border: "none",
              borderRadius: 10,
              cursor: "pointer",
            }}
          >
            重新加载
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
